var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAnalysis = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.313 2.063v5.812l-3.179 4.608a3.24 3.24 0 0 0-.572 1.837c0 .893.725 1.617 1.618 1.617h7.64c.893 0 1.617-.724 1.617-1.617 0-.656-.199-1.297-.571-1.837l-3.178-4.608V2.063M6 2.063h6m-6.75 8.812h7.5" }) }))); };
export default SvgAnalysis;
